import { action, computed, makeObservable } from 'mobx';
import {
  DraggableId,
  DragUpdate,
  DroppableId
} from '../../../../../lib/components/drag-n-drop';
import {logger} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {GapFillingModel, GapItem} from '../models';
import {checkAllItems, moveItemToGap, usedGapItemIds} from './dnd-utils';
import {DndGapFillingState, DndGapStates, gapItemsById, DndGapState} from './models';

export class DndGapFillingStore {

  constructor(readonly id: number,
              readonly model: GapFillingModel,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
    this.gapItemsById = gapItemsById(this.model);
  }

  readonly gapItemsById: { readonly [index: string]: GapItem };

  @computed
  get gapFillingState(): DndGapFillingState | null {
    const itemOrder = Object.keys(this.gapItemsById).sort((a, b) => 0.5 - Math.random());
    const states: {[index: string]: DndGapState} = {};

    itemOrder.map((value) => {
      Object.assign(states, {[value]: {checkCount: 0, checked: false, filledWith: null}})
    })
   
    const altGapFillingState: DndGapFillingState = {
      itemOrder,
      states
    }
    return this.stateStore.getContentState<DndGapFillingState>(this.id) ? this.stateStore.getContentState<DndGapFillingState>(this.id) : altGapFillingState;
  }

  @computed
  get itemOrder(): readonly string[] {
    const state = this.gapFillingState;
    if (state === null)
      return [];
    return state.itemOrder;
  }

  @computed
  get gapStates(): DndGapStates {
    const state = this.gapFillingState;
    if (state === null)
      return {};

    return state.states;
  }

  @computed
  get usedGapItemIds(): readonly string[] {
    const state = this.gapFillingState;
    if (state === null)
      return [];

    return usedGapItemIds(state.states);
  }

  canDropOn = (draggableId: DraggableId, source: DroppableId, destination: DroppableId): boolean => {
    return true;
  };

  @action
  onDragEnd = (result: DragUpdate): void => {
    const state = this.gapFillingState!;
    if (state === null)
      return;
    const {draggableId, fromDroppableId, toDroppableId} = result;

    this.updateState({
      itemOrder: state.itemOrder,
      states: moveItemToGap(state.states, draggableId, fromDroppableId, toDroppableId)
    });
  };

  onDragUpdate = (update: DragUpdate) => {
    logger.log('DndGapFillingStore.onDragUpdate', update);
  };

  @action
  check = () => {
    let gapFillingState = this.gapFillingState;
    if (gapFillingState === null)
      return;

    this.updateState({
      itemOrder: gapFillingState.itemOrder,
      states: checkAllItems(gapFillingState.states)
    });
  };

  @action
  private updateState(state: DndGapFillingState) {
    this.stateStore.setContentState<DndGapFillingState>(this.id, state);
  }
}
